import { Card, ThemeProvider } from "@mui/material";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import { BUSINESS_BCP_VALUE } from "constant";
import { usePagination } from "hooks/usePagination";
import moment from "moment";
import ReportBusinessFilter from "pages/reports/report-business/component/ReportBusinessFilter";
import { useMemo, useState } from "react";
import {
  useExportLogReportBusiness,
  useGetReportBusiness,
} from "service/query/report-business";
import muiTheme from "theme/muiTheme";

const ReportBusiness = () => {
  const [filter, setFilter] = useState({});
  const { data: reportBusiness, isFetching } = useGetReportBusiness(
    {
      ...filter,
    },
    { enabled: !!filter?.typeReport }
  );
  const {
    page,
    pageSize,
    handleChangePage,
    handleChangePageSize,
    clientData,
    clientTotal,
  } = usePagination(reportBusiness);

  const handleSubmit = (values) => {
    const from = moment(values.dateRange[0]).toISOString();
    const to = moment(values.dateRange[1]).toISOString();

    setFilter({
      typeReport: values.typeReport,
      from,
      to,
    });
    handleChangePage(1);
  };

  const { refetch: handleExport, isFetching: isFetchingExport } =
    useExportLogReportBusiness(filter, null);

  const columns = useMemo(
    () =>
      filter?.typeReport === BUSINESS_BCP_VALUE
        ? [
            {
              id: "province.cityCode",
              name: "Mã BĐ tỉnh",
            },
            {
              id: "province.address",
              name: "Tên BĐ tỉnh",
            },
            {
              id: "province.code",
              name: "Mã Bưu cục",
            },
            {
              id: "province.name",
              name: "Tên Bưu cục",
            },
            {
              id: "extensionName",
              name: "Mã máy lẻ",
            },
            {
              id: "inboundCall.count",
              name: "Số lượng gọi vào trong kỳ",
            },
            {
              id: "inboundCall.countTime",
              name: "Tổng phút gọi vào",
            },
            {
              id: "outboundCall.count",
              name: "Số lượng gọi ra trong kỳ",
            },
            {
              id: "outboundCall.countTime",
              name: "Tổng phút gọi ra",
            },
            {
              id: "outboundCall.onNet",
              name: "Tổng phút gọi ra nội mạng",
            },
            {
              id: "outboundCall.offNet",
              name: "Tổng phút gọi ra ngoại mạng",
            },
          ]
        : [
            {
              id: "province.cityCode",
              name: "Mã BĐ tỉnh",
            },
            {
              id: "province.address",
              name: "Tên BĐ tỉnh",
            },
            {
              id: "province.code",
              name: "Mã Bưu cục",
            },
            {
              id: "province.name",
              name: "Tên Bưu cục",
            },
            {
              id: "email",
              name: "Tài khoản",
            },
            {
              id: "name",
              name: "Tên tài khoản",
            },
            {
              id: "inboundCall.count",
              name: "Số lượng gọi vào trong kỳ",
            },
            {
              id: "inboundCall.countTime",
              name: "Tổng phút gọi vào",
            },
            {
              id: "outboundCall.count",
              name: "Số lượng gọi ra trong kỳ",
            },
            {
              id: "outboundCall.countTime",
              name: "Tổng phút gọi ra",
            },
            {
              id: "outboundCall.onNet",
              name: "Tổng phút gọi ra nội mạng",
            },
            {
              id: "outboundCall.offNet",
              name: "Tổng phút gọi ra ngoại mạng",
            },
          ],
    [filter?.typeReport]
  );

  return (
    <div>
      <ThemeProvider theme={muiTheme}>
        <Card sx={{ p: 2 }}>
          <ReportBusinessFilter
            onSubmit={handleSubmit}
            onExport={handleExport}
            isDisabledExport={!filter}
          />
        </Card>
        <Card sx={{ mt: 2 }}>
          <Table
            columns={columns}
            data={clientData}
            showHoverRow
            toolbar={{
              title: `${
                filter?.typeReport === BUSINESS_BCP_VALUE
                  ? "Báo cáo kinh doanh Bưu cục phát"
                  : "Báo cáo kinh doanh CSKH"
              } `,
            }}
            pagination={{
              page,
              pageSize,
              totalItems: clientTotal,
              onPageChange: handleChangePage,
              onPageSizeChange: handleChangePageSize,
            }}
            loading={isFetching}
          />
        </Card>
        <LoadingScreen loading={isFetching || isFetchingExport} />
      </ThemeProvider>
    </div>
  );
};

export default ReportBusiness;
